import React, { useContext, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { AuthContext } from "../../../../../Contexts/AuthContext/AuthProvider";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const InvestModal = (props) => {
  const { singledata, setmodalshow } = props;
  const { authUser } = useContext(AuthContext);

  // Handle submit form

  const refSubmitDis = useRef();
  const [InputData, setInputData] = useState([]);
  const navigate = useNavigate();

  const handleSubmitData = async (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    const storeData = { ...InputData, user_id: authUser?._id };
    try {
      const config = {
        headers: {
          "content-type": "application/json",
          authorization: `Beare ${authUser.token}`,
        },
      };

      await axios
        .post(
          `https://api.wlfmobile.com/api/user/investment/plan/store/${singledata?._id}`,
          storeData,
          config
        )
        .then((data) => {
          toast.success(`${data.data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          refSubmitDis.current.removeAttribute("disabled");
          if (data?.data?.success) {
            Swal.fire({
              title: `${data.data.message}`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/user/dashboard");
              }
            });
            setmodalshow(false);
          }
          event.target.reset();
        })
        .catch((error) => {
          toast.error(`${error?.response?.data?.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          refSubmitDis.current.removeAttribute("disabled");
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleMiningInputBlur = (event) => {
    const value = event.target.value;
    const field = event.target.name;
    const newUser = { ...InputData };
    newUser[field] = value;
    setInputData(newUser);
  };

  const [userData, setUserData] = useState([]);

  useEffect(() => {
    if (authUser?._id) {
      fetch(
        `https://api.wlfmobile.com/api/user/auth/view/${authUser?._id}`,
        {
          method: "GET",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setUserData(data.data);
        });
    }
  }, [authUser?._id]);

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4 className="modal-title">Invest Plan</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Name: </strong>
            {singledata?.promotion_name}
          </p>
          <p>
            <strong>Percentage:</strong>{" "}
            <span style={{ color: "#fff" }}>{singledata?.percentage}%</span>
          </p>

          <br />
          <p className="mb-1">
            <strong>Amount</strong>
          </p>
          <form onSubmit={handleSubmitData}>
            <div className="bargaining__fieldset">
              <div id="timeSelection" className="time-selection mt-2">
                <div className="period-buttons"></div>
              </div>
              <input
                className="field__input bargaining__field"
                type="number"
                name="amount"
                placeholder="Amount($)"
                required
                id="amount"
                onBlur={handleMiningInputBlur}
              />
            </div>

            <p className="pb-2">
              <strong>Available Balance: </strong>{" "}
              {!isNaN(userData?.balance) &&
                parseFloat(userData?.balance).toFixed(2)}
              $
            </p>

            <button
              className="btn btn-success  w-100 "
              data-bs-toggle="modal"
              style={{ borderRadius: "30px" }}
              ref={refSubmitDis}
            >
              Submit
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default InvestModal;
